import { classNames } from '@repo/ui/src/utils/classNames';
import IconWrapper, { IconWrapperProps } from '@repo/ui/src/components/IconWrapper';

interface RightChevronProps extends IconWrapperProps {
  darkMode?: boolean;
  onImage?: boolean;
  arrowSize?: string;
}

const RightChevron = ({ darkMode, onImage, arrowSize, ...rest }: RightChevronProps) => {
  const lightMode = !darkMode && !onImage;
  return (
    <IconWrapper
      aria-hidden="true"
      width={arrowSize ?? '40'}
      height={arrowSize ?? '40'}
      viewBox="0 0 52.36 52.36"
      className={classNames(
        'hover:tw-fill-warm-400',
        darkMode && 'tw-fill-warm-200',
        onImage && 'tw-fill-neutral-700 hover:tw-fill-neutral-500',
        lightMode && 'tw-fill-warm-300',
      )}
      {...rest}
    >
      <circle cx="24" cy="24" r="24" fill="inherit" />
      <path
        fill={classNames(onImage ? '#e9e9e6' : '#1a1a1a')}
        fillRule="evenodd"
        d="m21 14.1-1.414 1.415L28.07 24l-8.485 8.485L21 33.9l8.485-8.486L30.9 24l-1.415-1.414L21 14.1Z"
        clipRule="evenodd"
      />
    </IconWrapper>
  );
};

export default RightChevron;
